module.exports = __webpack_public_path__ + "static/media/hip-abduction.d77480ab.svg";